import { motion } from 'framer-motion';

const HeroSection = () => {
  return (
    <section className="relative min-h-[85vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/0ea37f7f8239dfaca5ff61c4cd7d3c32.jpg"
          alt="赤石会計事務所"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-red-dark/70 via-red-dark/60 to-red-dark/70"></div>
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-4 sm:px-8 w-full">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl"
        >
          <div className="inline-block mb-4 sm:mb-6 px-4 sm:px-5 py-2 border border-white/30 bg-white/15 backdrop-blur-sm rounded-full">
            <span className="text-white text-xs sm:text-[13px] font-medium">
              経営者のための会計事務所
            </span>
          </div>

          <h1 className="text-4xl sm:text-5xl md:text-7xl lg:text-[82px] font-bold text-white leading-[1.2] mb-6 sm:mb-8">
            <span className="text-red-light">勝つ</span>経営を<br />
            実現する
          </h1>

          <p className="text-base sm:text-lg text-white/90 leading-relaxed mb-8 sm:mb-12 max-w-[600px]">
            会計・税務・経営コンサルティングで、ビジネスを次のステージへ
          </p>

          <div className="flex flex-col sm:flex-row flex-wrap gap-3 sm:gap-4">
            <a
              href="#services"
              className="bg-red text-white px-8 sm:px-10 py-3 sm:py-4 rounded-full text-sm sm:text-[15px] font-medium hover:bg-red-dark transition-all hover:scale-105 whitespace-nowrap cursor-pointer text-center"
            >
              サービスを見る
            </a>
            <a
              href="#contact"
              className="bg-transparent border-2 border-white text-white px-8 sm:px-10 py-3 sm:py-4 rounded-full text-sm sm:text-[15px] font-medium hover:bg-white/10 transition-all whitespace-nowrap cursor-pointer text-center"
            >
              無料相談予約
            </a>
          </div>
        </motion.div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-2xl"></i>
      </div>
    </section>
  );
};

export default HeroSection;
